import classNames from 'classnames'
import { useHistory } from 'react-router'

import { pendingSelector } from 'api/selectors'
import { languageSelector } from 'i18n/selectors'
import { subscribeNews } from 'wordpress/actions'
import { componentSelector, subscriptionSelector } from 'wordpress/selectors'

import featureToggles from 'shared/featureToggles'

import Button from '@components/Button'
import SubscribeBackground from './SubscribeBackground'
import SubscribeForm from './SubscribeForm'

import styles from '../styles/Subscribe.module.scss'

const Subscribe = ({
    subscribeNews,
    subscribed,
    subscribeMessage,
    pending,
    translate,
    defaults,
    consentLabel,
    requireConsent,
    title,
    layout,
    language,
}) => {
    const history = useHistory()
    const subscribeTitle = () => (
        <h1 className={classNames('text-center', styles.subscribe__heading)}>{title || defaults.title}</h1>
    )

    const subscribingRedirectionLink =
        language === 'en' ? window.SUBSCRIBE_NEWS_REDIRECT_LINK_CA : window.SUBSCRIBE_NEWS_REDIRECT_LINK_FR

    return (
        <div
            className={classNames(
                'container',
                styles.subscribe,
                styles.subscribeWithBackground,
                featureToggles.caPurchaseFlow && 'd-flex flex-column align-items-center'
            )}>
            {layout ? (
                <>
                    {subscribeTitle()}
                    {featureToggles.caPurchaseFlow ? (
                        <Button
                            onClick={() => history.push(subscribingRedirectionLink)}
                            isLoading={pending}
                            block
                            size="large"
                            className={classNames('ml-sm-1', 'h3-mob', styles.subscribeButton)}
                            btnStyle="secondary">
                            <T>sign.up.news.btn.label</T>
                        </Button>
                    ) : (
                        <SubscribeForm
                            pending={pending}
                            subscribed={subscribed}
                            requireConsent={requireConsent}
                            defaults={defaults}
                            subscribeNews={subscribeNews}
                            translate={translate}
                            subscribeMessage={subscribeMessage}
                            consentLabel={consentLabel}
                        />
                    )}
                </>
            ) : (
                <SubscribeBackground
                    defaults={defaults}
                    subscribeTitle={subscribeTitle}
                    subscribeForm={
                        <SubscribeForm
                            pending={pending}
                            subscribe={subscribed}
                            requireConsent={requireConsent}
                            defaults={defaults}
                            subscribeNews={subscribeNews}
                            translate={translate}
                            subscribeMessage={subscribeMessage}
                            consentLabel={consentLabel}
                        />
                    }
                />
            )}
        </div>
    )
}

const pendingSubscriptionSelector = createSelector(pendingSelector, pendings => pendings['newsletterSubscription'])

const mapStateToProps = createSelector(
    componentSelector('newsletters'),
    subscriptionSelector,
    languageSelector,
    pendingSubscriptionSelector,
    (config, subscription, language, pending) => ({
        defaults: config,
        ...subscription,
        language,
        pending,
    })
)

export default compose(withTranslate, connect(mapStateToProps, { subscribeNews }))(Subscribe)
